import { TransferStep } from "../class/transferDetails";
import { TRANSFER_FLOW_IN, TransferFlow } from "../typings";

// Progress type:
/**
 * Transfer IN:
 * COnnect old account 5 - 45
 * Old account :[0,5, 10, 15, 20, 25, 30, 35, 40, 45]
 * ES plan name: 10
 * Statement choice / ES Details / Upload statement: 20
 * Has account: 30
 * Second account or more: 40
 * Connect old account - Confirm: 50
 *
 * DESTINATION: 60
 * Destination: [60]
 *
 * CONFIRM TRANSFER DETAILS: 65 - 100
 * Confirm details: 65
 * Personal details: 70
 * Martial details: 75
 * Mailing: 80
 * Signature: 90
 */
// Seperate transfer in / transfer out
const transferInStepProgress: Record<Partial<TransferStep>, number> = {
  // Connect old account
  STEP_OLD_ACCOUNT_SPONSOR_NAME: 10,
  STEP_OLD_ACCOUNT_HAS_ACCOUNT_STATEMENT: 20,
  STEP_OLD_ACCOUNT_UPLOAD_STATEMENT: 20,
  STEP_OLD_ACCOUNT_UPLOAD_STATEMENT_SUCCEED: 20,
  STEP_OLD_ACCOUNT_EMPLOYMENT_DETAILS: 20,
  STEP_OLD_ACCOUNT_PROVIDER_SEARCH: 20,
  STEP_OLD_ACCOUNT_PROVIDER_KNOWN_SCREEN: 20,
  STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT: 40,
  // FOR ALL SECOND ACCOUNTs == 40
  STEP_OLD_ACCOUNT_COMPLETED_HOME: 50,
  STEP_DESTINATION_FLASH_LOADING_TRANFER_IN: 50,

  STEP_DESTINATION_ACCOUNT: 60,

  STEP_CONFIRM_TRANSFER_DETAILS: 65,
  STEP_PERSONAL_INFO: 70, // Both in and out
  STEP_MARTIAL_INFO: 75, // Both in and out
  STEP_MAILING_ADDRESS: 80, // Both in and out
  STEP_INITIATE_TRANSFER: 90, // Both in and out

  // No Progress bar at all
  STEP_CONSENT: 0,
  STEP_TRANSFER_INFO: 0,
  STEP_OLD_ACCOUNT_CONFIRM: 40,
  STEP_OLD_ACCOUNT_FLASH_LOADING: 0,
  STEP_DESTINATION_IRA_FOUND: 0,
  STEP_DESTINATION_OPTIONS: 0,
  STEP_DESTINATION_OPTIONS_TYPE: 0,
  STEP_DESTINATION_CONNECT_IRA: 0,
  STEP_DESTINATION_CONNECT_IRA_TYPE: 0,
  STEP_DESTINATION_CONNECT_ES: 0,
  STEP_DESTINATION_CONNECT_ES_UPLOAD_STATEMENT: 0,
  STEP_DESTINATION_CONNECT_ES_DETAILS: 0,
  STEP_DESTINATION_HELP: 0,
  STEP_DESTINATION_HELP_RESULT: 0,
  STEP_DESTINATION_HELP_1: 0,
  STEP_DESTINATION_HELP_2: 0,
  STEP_DESTINATION_HELP_3: 0,
  STEP_DESTINATION_HELP_4: 0,
  STEP_DESTINATION_HELP_5: 0,
  STEP_DESTINATION_HELP_6A: 0,
  STEP_DESTINATION_HELP_6B: 0,
  STEP_DESTINATION_HELP_6C: 0,
  STEP_DESTINATION_HELP_RESULT_LOADING: 0,
  STEP_DESTINATION_EXPLORE_IRA: 0,
  STEP_DESTINATION_EXPLORE_IRA_1: 0,
  STEP_DESTINATION_EXPLORE_IRA_2: 0,
  STEP_DESTINATION_EXPLORE_IRA_3: 0,
  STEP_DESTINATION_EXPLORE_IRA_LOADING: 0,
  STEP_DESTINATION_EXPLORE_IRA_RESULT: 0,
  STEP_DESTINATION_EXPLORE_IRA_OPTIONS: 0,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY: 0,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT: 0,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD: 0,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI: 0,
  STEP_POST_TRANSFER: 0, // Both in and out
  STEP_IRA_OPEN_FORM: 0,
  STEP_SCHEDULE_PHONE_CALL: 0, // Both in and out
  STEP_SCHEDULE_PHONE_CALL_NO_LOADING: 0,
  STEP_IRA_EXIT_SCREEN: 5, // Both in and out
  STEP_OPEN_IRA: 0, // Both in and out
  STEP_SCHEDULE_PHONE_CALL_CONFIRMATION: 0,
  STEP_DESTINATION_OPEN_AND_CONNECT_IRA: 0,
  STEP_DESTINATION_IRA_METHODOLOGY_SCREEN: 0,
  STEP_DESTINATION_METHODOLOGY_SCREEN: 0,
};

/**
 * Transfer out:
 * Old account :[0,5]
 * OLD ACCOUNT: 5
 * Confirm Account details: 5/100
 *
 * DESTINATION: 10 - 60
 * Destination: [10, 15, 20, 25, 30, 35, 40, 45, 55, 60]
 * IRA account | Transfer Destination: 10
 *
 * Transfer destination Account type: 15
 * Henry Questionnaire: 15 (Intro)
 *
 * Henry Questionnaire Questions: (Q1)15, (Q2)25, (Q3)30, (Q4)35, (Q5)40, (Result)45
 *
 * IRA Questionnaire: (Q1)45 - (Q3)50 - (Result)55
 *
 * Provide IRA Details: 50
 * Provide ES Details: 50 (Es Name) - 55 (Upload / ES Details)
 *
 * Confirm Destination: 60
 *
 * CONFIRM TRANSFER DETAILS: 65 - 100
 * Confirm details: 65
 * Personal details: 70
 * Martial details: 75
 * Mailing: 80
 * Signature: 90
 */

const transferOutStepProgress: Record<Partial<TransferStep>, number> = {
  STEP_OLD_ACCOUNT_COMPLETED_HOME: 5, // 5%

  // CONNECT DESTINATION - Entry
  STEP_DESTINATION_IRA_FOUND: 10, // Transfer out - 10%
  STEP_DESTINATION_OPTIONS: 10, // Transfer out - 15%

  // CONNECT DESTINATION - EXPLORE ENTRY
  STEP_DESTINATION_OPTIONS_TYPE: 15, // Transfer out
  STEP_DESTINATION_HELP: 15, // Transfer out

  // HENRY QUESTIONNAIRE [15 - 55] - EXPLORE DETAILS
  STEP_DESTINATION_HELP_1: 20, // Transfer out
  STEP_DESTINATION_HELP_2: 25, // Transfer out
  STEP_DESTINATION_HELP_3: 30, // Transfer out
  STEP_DESTINATION_HELP_4: 35, // Transfer out
  STEP_DESTINATION_HELP_5: 40, // Transfer out
  STEP_DESTINATION_HELP_6A: 40, // Transfer out
  STEP_DESTINATION_HELP_6B: 40, // Transfer out
  STEP_DESTINATION_HELP_6C: 40, // Transfer out
  STEP_DESTINATION_HELP_RESULT_LOADING: 45, // Transfer out
  STEP_DESTINATION_HELP_RESULT: 45, // Transfer out
  STEP_DESTINATION_METHODOLOGY_SCREEN: 45,

  // IRA Partnership
  STEP_DESTINATION_EXPLORE_IRA: 45, // Transfer out
  STEP_DESTINATION_EXPLORE_IRA_1: 50, // Transfer out
  STEP_DESTINATION_EXPLORE_IRA_2: 50, // Transfer out
  STEP_DESTINATION_EXPLORE_IRA_3: 50, // Transfer out
  STEP_DESTINATION_EXPLORE_IRA_LOADING: 50, // Transfer out

  // CONNECT DESTINATION - CONFIRM TYPE AND PROVIDE DETAILS
  STEP_DESTINATION_CONNECT_ES: 50, // Transfer out
  STEP_DESTINATION_CONNECT_ES_DETAILS: 55, // Transfer out
  STEP_DESTINATION_CONNECT_ES_UPLOAD_STATEMENT: 55, // Transfer out

  STEP_DESTINATION_EXPLORE_IRA_RESULT: 55, // Transfer out
  STEP_DESTINATION_EXPLORE_IRA_OPTIONS: 55, // Transfer out
  STEP_DESTINATION_IRA_METHODOLOGY_SCREEN: 55,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY: 55, // Transfer out
  STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT: 55, // Transfer out
  STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI: 55, // Transfer out
  STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD: 55, // Transfer out
  STEP_DESTINATION_OPEN_AND_CONNECT_IRA: 55,
  STEP_DESTINATION_CONNECT_IRA_TYPE: 45, // Transfer out (This is the screen after user confirm to transfer into IRA)
  STEP_DESTINATION_CONNECT_IRA: 55, // Transfer out

  // CONNECT DESTINATION - Final
  STEP_DESTINATION_ACCOUNT: 60,

  // TRANSFER DETAILS
  // Transfer details [ 65 - 100]
  STEP_CONFIRM_TRANSFER_DETAILS: 65,
  STEP_PERSONAL_INFO: 70, // Both in and out
  STEP_MARTIAL_INFO: 75, // Both in and out
  STEP_MAILING_ADDRESS: 80, // Both in and out
  STEP_IRA_OPEN_FORM: 85,
  STEP_INITIATE_TRANSFER: 90, // Both in and out

  // No progress bar at all
  STEP_CONSENT: 0,
  STEP_TRANSFER_INFO: 0,

  // CONNECT OLD ACCOUNT
  STEP_OLD_ACCOUNT_CONFIRM: 0, // Transfer out
  STEP_OLD_ACCOUNT_FLASH_LOADING: 0, // Transfer out
  STEP_POST_TRANSFER: 0, // Both in and out
  STEP_SCHEDULE_PHONE_CALL: 0, // Both in and out
  STEP_SCHEDULE_PHONE_CALL_NO_LOADING: 0,
  STEP_IRA_EXIT_SCREEN: 0, // Both in and out
  STEP_OPEN_IRA: 0, // Both in and out
  STEP_SCHEDULE_PHONE_CALL_CONFIRMATION: 0,
  STEP_OLD_ACCOUNT_SPONSOR_NAME: 0,
  STEP_OLD_ACCOUNT_HAS_ACCOUNT_STATEMENT: 0,
  STEP_OLD_ACCOUNT_UPLOAD_STATEMENT: 0,
  STEP_OLD_ACCOUNT_UPLOAD_STATEMENT_SUCCEED: 0,
  STEP_OLD_ACCOUNT_EMPLOYMENT_DETAILS: 0,
  STEP_OLD_ACCOUNT_PROVIDER_SEARCH: 0,
  STEP_OLD_ACCOUNT_PROVIDER_KNOWN_SCREEN: 0,
  STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT: 0,
  STEP_DESTINATION_FLASH_LOADING_TRANFER_IN: 0,
};

const getTransferProgress = (step: TransferStep, transferFlow: TransferFlow): number => {
  const index = transferFlow === TRANSFER_FLOW_IN ? transferInStepProgress[step] : transferOutStepProgress[step];
  const stepTotal = 100;

  if (!index) {
    return 0;
  } else {
    return index / stepTotal;
  }
};

export default getTransferProgress;
